import { paths, unauthRoutes } from 'app/routes'
import { UnauthLayout } from 'components/unauth-layout'
import { Navigate, useRoutes } from 'react-router-dom'

export const UnauthApp = () => {
  return (
    <UnauthLayout>
      {useRoutes([
        ...unauthRoutes,
        {
          path: '*',
          element: <Navigate replace to={paths.signIn} />,
        },
      ])}
    </UnauthLayout>
  )
}
